import { getEnv } from './ajax'
import lang, { langId } from '../lang'

// This is fetched before initial render
export let env = null

let resolveEnv
window.envPromise = new Promise(resolve => {
	resolveEnv = resolve
})

export async function loadEnv() {
	env = await getEnv()
	resolveEnv(env)
}

const SPECIAL_COUNTRIES = {
	AX: {
		id: 'ala',
		idShort: 'ax',
		nameInLocalLanguage: 'Åland',
		nameInEnglish: 'Åland',
	},
}

export function getEnabledCountries() {
	let enabledCountries = window.ENABLED_COUNTRIES.map(enabledCountry => {
		if (SPECIAL_COUNTRIES[enabledCountry]) {
			return SPECIAL_COUNTRIES[enabledCountry]
		}

		let countryKey = Object.keys(env.COUNTRIES).find(key => {
			return env.COUNTRIES[key].idShort.toUpperCase() === enabledCountry.toUpperCase()
		})

		if (!countryKey) console.error('invalid country', enabledCountry)

		return countryKey && env.COUNTRIES[countryKey]
	})
	let langIsInited = lang && lang.signup && lang.signup.country

	if (langIsInited) {
		enabledCountries = enabledCountries.sort((a, b) => {
			// This crashes (at least in IE) with:
			// Unhandled promise rejection TypeError: Unable to get property 'country' of undefined
			// or null reference

			let langIsInited = lang && lang.signup && lang.signup.country

			let aName = (langIsInited && lang.signup.country[a.idShort]) || a.nameInLocalLanguage
			let bName = (langIsInited && lang.signup.country[b.idShort]) || b.nameInLocalLanguage

			return aName.localeCompare(bName, langId)
		})
	}

	return enabledCountries
}

export function guessCountry() {
	return getCountryObject(env.countryCodeBasedOnIP || 'FI') || getEnabledCountries().find(country => country.id === 'fin')
}

// long or short id
export function getCountryObject(id) {
	id = id.toLowerCase()
	const enabledCountries = getEnabledCountries()
	return enabledCountries.find(country => country.id === id || country.idShort === id)
}
